export default __webpack_public_path__ + "static/media/X.c97204da.svg";